import { CampaignUpdateDialogController } from './campaign-update-dialog.controller'

function campaignUpdateDialog () {
  return {
    restrict: 'E',
    controller: CampaignUpdateDialogController,
    templateUrl: '/campaigns/dialogs/campaign-update/campaign-update-dialog.html?$$REVISION$$'
  }
}
export { campaignUpdateDialog }
